import axios from 'axios';

const baseUrl = window.config.API_URL;
const creatingHeadingBlock = async (state) => {
  const linkid = localStorage.getItem('linkId');
  const { token } = JSON.parse(localStorage.getItem('user'));
  const userID = JSON.parse(localStorage.getItem('user')).userid;
  const coloumnValue = state?.coloum_value;
  const coloumnType = state?.coloum_type || null;
  const columnName = state?.columnName;
  const headingCustomizationData = {
    columnName,
    coloumnType,
    coloumnValue,
    linkid,
    userID,
  };
  const postData = JSON.stringify(headingCustomizationData);
  const path = `/api/user/createBlock`;
  const url = baseUrl + path;
  const response = await axios.post(url, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `'Bearer ' ${token}`,
    },
    data: postData,
  });

  return response.data;
};
const changeStatusBlock = async (state) => {
  const { token } = JSON.parse(localStorage.getItem('user'));
  const status = state?.status;
  const optionid = state?.optionid;
  // const coloumnType = state?.coloum_type || null
  // const columnName = state?.columnName
  const headingCustomizationData = {
    status,
    optionid,
  };
  // const statusPostData = JSON.stringify(headingCustomizationData);

  const path = `/api/user/changeBlockStatus`;
  const url = baseUrl + path;
  const response = await axios.post(url, {
    headers: {
      'Content-Type': 'multipart/form-data',
      Authorization: `'Bearer ' ${token}`,
    },
    data: headingCustomizationData,
  });

  return response.data;
};
const creatingSocialBlock = async (state) => {
  const linkid = localStorage.getItem('linkId');
  const { token } = JSON.parse(localStorage.getItem('user'));
  const userID = JSON.parse(localStorage.getItem('user')).userid;
  // const telegramState = state?.telegramState;
  const colorState = state?.colorState;
  const sizeState = state?.sizeState;
  const emailState = state?.emailState;
  const phoneState = state?.phoneState;
  const facebookState = state?.facebookState;
  const massengerState = state?.massengerState;
  const instagramState = state?.instagramState;
  const twitterState = state?.twitterState;
  const tiktokState = state?.tiktokState;
  const youtubeState = state?.youtubeState;
  const soundcloudState = state?.soundcloudState;
  const linkedinState = state?.linkedinState;
  const spotifyState = state?.spotifyState;
  const pinterestState = state?.pinterestState;
  const twitchState = state?.twitchState;
  // const discordState = state?.discordState;
  const snapchatState = state?.snapchatState;
  const columnName = state?.columnName;

  const headingCustomizationData = {
    columnName,
    colorState,
    sizeState,
    emailState,
    phoneState,
    // telegramState,
    facebookState,
    massengerState,
    instagramState,
    twitterState,
    tiktokState,
    youtubeState,
    soundcloudState,
    linkedinState,
    spotifyState,
    pinterestState,
    snapchatState,
    twitchState,
    // discordState,
    linkid,
    userID,
  };
  const data = JSON.stringify(headingCustomizationData);
  const path = `/api/user/createSocialBlock`;
  const url = baseUrl + path;
  const response = await axios.post(url, data, {
    headers: {
      'Content-Type': 'application/json',

      // 'Content-Type': 'multipart/form-data',
      Authorization: `'Bearer ' ${token}`,
    },
  });

  return response.data;
};
const creatingLinkBlock = async (state) => {
  const linkid = localStorage.getItem('linkId');
  const { token } = JSON.parse(localStorage.getItem('user'));
  const userID = JSON.parse(localStorage.getItem('user')).userid;
  const coloumnValue = state?.coloum_value;
  const coloumnType = state?.coloum_type || null;
  const columnName = state?.columnName;
  const headingCustomizationData = {
    columnName,
    coloumnType,
    coloumnValue,
    linkid,
    userID,
  };
  const postData = JSON.stringify(headingCustomizationData);
  const path = `/api/user/createLinkBlock`;
  const url = baseUrl + path;
  const response = await axios.post(url, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `'Bearer ' ${token}`,
    },
    data: postData,
  });

  return response.data;
};

const creatingFaqBlock = async (state) => {
  const linkId = localStorage.getItem('linkId');
  const userID = JSON.parse(localStorage.getItem('user')).userid;

  const faqData = [];
  if (state?.title_one || state?.description_one) {
    faqData.push({ title: state?.title_one, description: state?.description_one });
  }
  if (state?.title_two || state?.description_two) {
    faqData.push({ title: state?.title_two, description: state?.description_two });
  }
  if (state?.title_three || state?.description_three) {
    faqData.push({ title: state?.title_three, description: state?.description_three });
  }

  const coloumnValue = faqData;
  const coloumnType = state?.coloum_type || null;
  const columnName = state?.columnName;

  const data = {
    columnName,
    coloumnType,
    coloumnValue,
    linkId,
    userID,
  };
  // const postData = JSON.stringify(data);
  const path = `/api/user/createfaqBlock`;
  const url = baseUrl + path;
  const response = await axios.post(url, data);

  return response.data;
};

const creatingShareBlock = async (state) => {
  const linkId = localStorage.getItem('linkId');
  const userID = JSON.parse(localStorage.getItem('user')).userid;
  const uerrNamee = JSON.parse(localStorage.getItem('linkData')) || {};
  const link = uerrNamee[0]?.link;
  const coloumnType = state?.coloum_type || null;
  const columnName = state?.columnName || 'share';
  const data = {
    columnName,
    coloumnType,
    link,
    linkId,
    userID,
  };

  const path = `/api/user/generateQRCode`;
  const url = baseUrl + path;
  const response = await axios.post(url, data);

  return response.data;
};
const blockService = {
  creatingHeadingBlock,
  creatingSocialBlock,
  changeStatusBlock,
  creatingLinkBlock,
  creatingFaqBlock,
  creatingShareBlock,
};
export default blockService;
